(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cbg-dealer"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cbg-dealer-toggle').forEach(button => {
  const target = document.getElementById(button.getAttribute('aria-controls'));
  if (!target) return;
  const labels = button.closest('.cbg-dealer');
  button.addEventListener('click', () => {
    const visible = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(visible));
    target.hidden = !visible;
    button.textContent = visible ? labels.dataset.hideLabel : labels.dataset.showLabel;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  document.querySelectorAll('[data-cbg-dealer-bar]').forEach((bar) => {
    const button = bar.querySelector('[data-cbg-dealer-toggle]');
    if (!button) return;
    const showLabel = bar.dataset.showLabel;
    const hideLabel = bar.dataset.hideLabel;
    let enabled = false;
    try { enabled = sessionStorage.getItem('cbg-dealer-view') === 'on'; } catch (error) {}
    const apply = (next) => {
      enabled = next;
      document.body.classList.toggle('cbg-dealer-view-enabled', enabled);
      button.checked = enabled;
      try { sessionStorage.setItem('cbg-dealer-view', enabled ? 'on' : 'off'); } catch (error) {}
    };
    button.addEventListener('change', () => apply(button.checked));
    apply(enabled);
  });

  } catch(e) { console.error(e); }
})();
})();
